import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { PropType, Ref } from 'vue'
import Empty from './Empty.vue'


const __default__ = { name: 'BoardGaugeChart' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '240px'
  },
  data: {
    type: Array as PropType<any[]>,
    default: () => {
      return []
    }
  }
},
  setup(__props) {

const props = __props
const showECharts = ref(false)
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
watch(
  () => props.data,
  (v) => {
    initChart()
  }
)
const initChart = () => {
  showECharts.value = props.data.length > 0
  const option = {
    tooltip: {
      trigger: 'item',
      backgroundColor: '#000',
      textStyle: {
        color: '#fff'
      },
      // formatter: function (params) {
      //   return props.data[params[0].dataIndex].tooltip
      // }
    },
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        min: 0,
        radius: '90%',
        pointer: {
          show: false
        },
        progress: {
          show: true,
          overlap: false
        },
        axisLine: {
          lineStyle: {
            width: 20
          }
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false
        },
        data: props.data,
        title: {
          fontSize: 16,
          color: '#5B687D',
          offsetCenter: ['0%', '15%']
        },
        detail: {
          fontSize: 26,
          offsetCenter: ['0%', '-15%'],
          color: '#26292E',
          formatter: '{value}%'
        }
      }
    ]
  }
  setOptions(option)
}

onMounted(() => {
  initChart()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      ref_key: "chartRef",
      ref: chartRef,
      style: _normalizeStyle({ width: __props.width, height: __props.height })
    }, null, 4), [
      [_vShow, showECharts.value]
    ]),
    (!showECharts.value)
      ? (_openBlock(), _createBlock(Empty, {
          key: 0,
          style: _normalizeStyle({ width: __props.width, height: __props.height })
        }, null, 8, ["style"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})